import { composerBilan, composerPartage, composerEmployeur, PAGE_PARTAGE } from './modeleBilan'
import { IMAGES_BILAN } from './imagesBilan'
import { ouvrirDocumentPdf, dessinerComposition } from '../Certificat/pdfCertificat'
import { mesureurCanevas, policePrete } from '../Certificat/mesure'
import { values as LIBELLES } from '../../../contexts/LanguageContext'

/* ⛔ BILAN SOFT SKILLS, RENDU PDF (07/10/2026, etape 1, MAQUETTE : aucun
   ecran ne l'appelle encore).
   La methode du certificat, et ses fonctions (Certificat/pdfCertificat.js) :
   jsPDF dans le navigateur, dessin VECTORIEL, textes PDF en Questrial
   embarquee (nets a tout zoom, selectionnables) ; seuls le logo et la
   signature sont des images. Rien n'est envoye au serveur.
   v2 : DEUX pages A4 portrait (la vitrine, puis « Prépare ton entretien »).
   L'image de partage (4:5) passe par le meme dessin, sur une page de
   216 x 270 mm (`fabriquerPdfPartage`) : rendue a 127 dpi, elle fait
   1080 x 1350 px.
   v3 : la page « pour un employeur » (`fabriquerPdfEmployeur`), une page A4.
   Une page qui deborderait n'est pas fabriquee : mieux vaut aucun bilan qu'un
   bilan coupe. */

export { IMAGES_BILAN }

export const nomDuFichierBilan = ({ prenomNom, langue = 'fr' }) => {
  const base = LIBELLES?.bilanSoftSkills?.nomFichier?.[langue] || 'bilan-soft-skills'
  const nom = String(prenomNom || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60)
  return base + (nom ? '-' + nom : '') + '.pdf'
}

const verifier = (donnees) => {
  if (!String(donnees?.prenomNom || '').trim() || !donnees?.contenu) {
    throw new Error('bilan\u00a0: nom ou contenu absent, aucun PDF fabriqué')
  }
}
const proprietes = (donnees) => ({
  title: [LIBELLES?.bilanSoftSkills?.mention?.[donnees?.langue || 'fr'] || 'Bilan soft skills', donnees?.prenomNom].filter(Boolean).join(', '),
  author: 'Rising Up',
  creator: 'THE LAB, Rising Up',
})

export const fabriquerPdfBilan = async (donnees) => {
  verifier(donnees)
  await policePrete()
  const composition = composerBilan({ ...donnees, dateDelivrance: donnees?.dateDelivrance || new Date(), mesurer: mesureurCanevas() })
  if (composition.deborde) throw new Error('bilan\u00a0: le contenu ne tient pas sur ses pages, aucun PDF fabriqué')
  const doc = await ouvrirDocumentPdf({ orientation: 'portrait', proprietes: proprietes(donnees) })
  const images = IMAGES_BILAN[composition.variante]
  for (let i = 0; i < composition.pages.length; i++) {
    if (i > 0) doc.addPage('a4', 'portrait')
    await dessinerComposition(doc, composition.pages[i], images)
  }
  return doc
}

export const fabriquerPdfPartage = async (donnees) => {
  verifier(donnees)
  await policePrete()
  const composition = composerPartage({ ...donnees, dateDelivrance: donnees?.dateDelivrance || new Date(), mesurer: mesureurCanevas() })
  if (composition.deborde) throw new Error('bilan\u00a0: l’image de partage ne tient pas, rien n’est fabriqué')
  const doc = await ouvrirDocumentPdf({ orientation: 'portrait', format: [PAGE_PARTAGE.largeur, PAGE_PARTAGE.hauteur], proprietes: proprietes(donnees) })
  return dessinerComposition(doc, composition, IMAGES_BILAN[composition.variante])
}

export const fabriquerPdfEmployeur = async (donnees) => {
  verifier(donnees)
  await policePrete()
  const composition = composerEmployeur({ ...donnees, dateDelivrance: donnees?.dateDelivrance || new Date(), mesurer: mesureurCanevas() })
  if (composition.deborde) throw new Error('bilan' + String.fromCharCode(160) + ': la page employeur ne tient pas, aucun PDF fabriqué')
  const doc = await ouvrirDocumentPdf({ orientation: 'portrait', proprietes: proprietes(donnees) })
  return dessinerComposition(doc, composition, IMAGES_BILAN[composition.variante])
}

export const telechargerPdfEmployeur = async (donnees) => {
  const doc = await fabriquerPdfEmployeur(donnees)
  doc.save(nomDuFichierBilan(donnees).replace(/\.pdf$/, '-employeur.pdf'))
  return true
}

export const telechargerBilanPdf = async (donnees) => {
  const doc = await fabriquerPdfBilan(donnees)
  doc.save(nomDuFichierBilan(donnees))
  return true
}
